import { zodEmPortugues } from '@bia/protocol'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import { createRoot } from 'react-dom/client'
import {
  AppCrashBoundary,
  RouteError,
  RouteNotFound,
  RoutePending,
} from './components/state/RouteFallbacks'
import './index.css'
import { initSentry } from './observability/sentry'
import { routeTree } from './routeTree.gen'
import { instalarRolagem } from './ui/rolagem'

// Antes de qualquer schema: a mensagem do Zod aparece nos formulários.
zodEmPortugues()

// Sem VITE_SENTRY_DSN não faz nada. Fica antes do router para pegar erro de
// montagem também.
initSentry()

// A barra de rolagem só aparece enquanto rola; quem marca é este listener.
instalarRolagem()

// Rota sem tela própria de erro, de 404 ou de espera usa estas.
const router = createRouter({
  routeTree,
  defaultPreload: false,
  defaultErrorComponent: RouteError,
  defaultNotFoundComponent: RouteNotFound,
  defaultPendingComponent: RoutePending,
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')
if (container === null) throw new Error('#root não existe')

// Sem StrictMode de propósito: a montagem dupla do modo estrito abre e fecha
// o socket e o AudioContext da sala duas vezes, e a sala tem uma conexão só.
createRoot(container).render(
  <AppCrashBoundary>
    <RouterProvider router={router} />
  </AppCrashBoundary>,
)
